import type { Ancestor } from "@/entities/ancestor";

import { getDirectParentByType } from "@/entities/ancestor";

export const getLocationSelectOptionValue = (ancestors: Ancestor[]) => {
  const location = getDirectParentByType(ancestors, "location");

  if (!location) return undefined;

  return {
    value: location.id,
    label: location.name,
    key: location.id,
  };
};
